import { render, staticRenderFns } from "./BankUndepositedFundDetail.vue?vue&type=template&id=13e26c1c"
import script from "./BankUndepositedFundDetail.vue?vue&type=script&lang=js"
export * from "./BankUndepositedFundDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e26c1c')) {
      api.createRecord('13e26c1c', component.options)
    } else {
      api.reload('13e26c1c', component.options)
    }
    module.hot.accept("./BankUndepositedFundDetail.vue?vue&type=template&id=13e26c1c", function () {
      api.rerender('13e26c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bankundepositedfund/BankUndepositedFundDetail.vue"
export default component.exports